const windowSize = {
    sm: "(max-width:767px)",
    base: "(min-width:768px) and (max-width:1023px)",
    lg: "(min-width: 1024px)",
    drawerTransition : "all 300ms ease-in-out"
};

const fontSize = {
    xs: '0.5rem',
    sm: '0.75rem',
    base: '0.9rem',
    bmd: '1.1rem',
    md: '1.25rem',
    lg: '1.5rem',
};

const color = {
    // primary : '#F75858',
    // secondary: '#F37374',
    logo:'#ff1616',
    shadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
    request: '#E3F5FF',
    setting: '#C6C7F8',
    coding: '#FFE999',
    complete: '#E5ECF6',
    setting2: '#6bb5b0',
    coding2: '#f2b54e',
    complete2: '#71706f',
    primary : {
        main: '#F7F9FB',
        blue: '#E3F5FF',
        pupple: '#E5ECF6',
        pupple2: 'rgba(229, 236, 246, 0.5)',
        333: '#333333',
    },
    secondary: {
        puppleA: '#95A4FC',
        puppleB: '#C6C7F8',
        blueA: '#A8C5DA',
        blueB: '#B1E3FF',
        greeanA: '#A1E3CB',
        greenB: '#BAEDBD',
        yellow: '#FFE999',
        red: '#FF4747',
        // red: '#FF0000',
        redA: '#FF6347',    //SJK
        redB: '#FF8C00',    //SJK
    },
    black: {
        100: '#1C1C1C',
        80: 'rgba(0, 0, 0, 0.8)',
        60: 'rgba(0, 0, 0, 0.6)', //Modal Background only
        40: 'rgba(0, 0, 0, 0.4)',
        20: 'rgba(0, 0, 0, 0.2)',
        10: 'rgba(0, 0, 0, 0.1)',
        5: 'rgba(0, 0, 0, 0.05)',
    },
    white: {
        100: '#ffffff',
        80: 'rgba(255, 255, 255, 0.8)',
        40: 'rgba(255, 255, 255, 0.4)',
        20: 'rgba(255, 255, 255, 0.2)',
        10: 'rgba(255, 255, 255, 0.1)',
        5: 'rgba(255, 255, 255, 0.05)',
    }
}

const background = {
    // main: '#F5ECED',
    // header: '#FEEEEE',
    // card: '#FCDCDD',
    // main: '#FFFFFF',
    // header: '#FEEEEE',
    // card: '#FFF7F7',
    // main: '#ffffff',
    // header: '#ffffff',
    // card: '#f4f5f6',
    main: '#f4f5f6',
    header: '#f4f5f6',
    card: '#ffffff',
    sub: '#f9f9f9',
}

const theme = {windowSize, fontSize, color, background}
export default theme;